var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicForm',{attrs:{"dynamicFormType":"biomicroscopy","answerableId":_vm.attendance.id,"answerableType":"Attendance","disabled":true}})}
var staticRenderFns = []

export { render, staticRenderFns }